
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Mumbaiairporttobhanoricabs() {



    const cardData =
    {
        keyword: 'Mumbai Airport to Dhanori Cab',
        heading: 'Mauli Cabs: Mumbai Airport to Dhanori Cab',
        headingDescription: 'Mauli Cabs offers convenient and reliable Mumbai Airport to Dhanori Cab services, ensuring a smooth and comfortable journey from Chhatrapati Shivaji Maharaj International Airport to Dhanori, Pune. Our fleet includes well-maintained sedans, SUVs, and premium vehicles to match your travel needs. With professional drivers, on-time pickups, transparent pricing, and no hidden charges, Mauli Cabs guarantees a stress-free and dependable travel experience. We also offer flexible options for both one-way and round-trip bookings.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

       "topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is a historical fortification in Pune, built in 1732. It was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and rich history."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument with deep historical significance, as it served as a prison for Mahatma Gandhi and other national leaders during the Quit India Movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located about 30 km from Pune, Sinhagad Fort is a popular trekking destination offering panoramic views, historical significance, and remnants of Maratha architecture."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "The Pataleshwar Cave Temple is a rock-cut temple dating back to the 8th century, dedicated to Lord Shiva. It’s known for its monolithic architecture and serene ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts, including sculptures, musical instruments, household items, and paintings reflecting India’s diverse heritage."
    },
    {
        "title": "Dagdusheth Halwai Ganapati Temple",
        "description": "One of the most famous temples in Pune, it is dedicated to Lord Ganesha and visited by thousands of devotees daily. The temple is especially vibrant during Ganesh Chaturthi."
    },
    {
        "title": "Osho Garden & Osho Ashram",
        "description": "Located in Koregaon Park, this tranquil garden and ashram are associated with spiritual leader Osho and offer peaceful surroundings ideal for meditation and reflection."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage structures in Pune, offering stunning city views and home to several ancient temples including the Parvati Temple."
    },
    {
        "title": "Katraj Snake Park & Rajiv Gandhi Zoological Park",
        "description": "A favorite among families and kids, this park features a wide range of snakes, reptiles, and other animals in a well-maintained environment."
    },
    {
        "title": "Lal Mahal",
        "description": "The Lal Mahal is a red-colored historical landmark where Shivaji Maharaj spent his childhood. It offers a glimpse into Maratha history and heroic tales."
    }
],

"services": [
    {
      "name": "Mumbai Airport to Dhanori Cab Service",
      "description": "Book a reliable and efficient cab service from Mumbai Airport to Dhanori, a bustling locality in Pune. Whether you are traveling for business, leisure, or visiting family, our service ensures timely pickups, well-maintained vehicles, and experienced drivers for a smooth, comfortable journey to Dhanori."
    },
    {
      "name": "Book Mumbai Airport to Dhanori Taxi",
      "description": "Booking a taxi from Mumbai Airport to Dhanori is easy with our quick and straightforward online booking platform. Choose from a variety of vehicles to suit your preferences and budget. Our fleet includes options such as sedans, SUVs, and luxury vehicles for a comfortable ride to Dhanori."
    },
    {
      "name": "Affordable Mumbai Airport to Dhanori Cab",
      "description": "Travel affordably from Mumbai Airport to Dhanori with our budget-friendly cab services. We offer transparent pricing, with no hidden fees, ensuring you get a reliable ride at a competitive price. Perfect for cost-conscious travelers who want a hassle-free journey."
    },
    {
      "name": "Private Taxi from Mumbai Airport to Dhanori",
      "description": "Opt for a private taxi from Mumbai Airport to Dhanori for a more personalized travel experience. Our private cabs offer a direct, non-shared ride, ensuring that you travel in comfort and privacy, with the flexibility to stop as needed along the way."
    },
    {
      "name": "Dhanori Trip by Cab from Mumbai Airport",
      "description": "Planning a trip to Dhanori? Book a cab directly from Mumbai Airport and enjoy a smooth, stress-free ride. Our experienced drivers will take you to Dhanori in the most efficient route, ensuring you arrive on time, whether for business meetings or leisure activities."
    },
    {
      "name": "Comfortable Taxi Ride to Dhanori",
      "description": "Sit back and relax during your taxi ride from Mumbai Airport to Dhanori. Our vehicles are air-conditioned, well-maintained, and spacious, providing a comfortable and pleasant ride. Whether you're traveling alone or with a group, we ensure your comfort throughout the journey."
    },
    {
      "name": "Luxury Taxi for Dhanori Trip",
      "description": "For those seeking a more luxurious experience, choose a premium taxi for your ride from Mumbai Airport to Dhanori. Our luxury vehicles offer plush interiors, advanced climate control, and top-notch amenities, ensuring a high-end travel experience for those who want to travel in style."
    },
    {
      "name": "Group Travel to Dhanori from Mumbai Airport",
      "description": "Traveling with a group? Our spacious vehicles such as Innovas and Tempo Travellers are perfect for group travel from Mumbai Airport to Dhanori. These vehicles provide ample space for passengers and luggage, making it ideal for family trips, business groups, or friends traveling together."
    }
  ],
  "tableData": [
    ["Mumbai Airport to Dhanori Cab Service", "Book Mumbai Airport to Dhanori Taxi"],
    ["Affordable Mumbai Airport to Dhanori Cab", "Private Taxi from Mumbai Airport to Dhanori"],
    ["Dhanori Trip by Cab from Mumbai Airport", "Comfortable Taxi Ride to Dhanori"],
    ["Luxury Taxi for Dhanori Trip", "Group Travel to Dhanori from Mumbai Airport"]
  ],

"whychoose": [
    {
        "WhyChooseheading": "Reliable Cabs from Mumbai Airport to Dhanori",
        "WhyChoosedescription": "Mauli Cabs offers trustworthy and convenient cab services from Mumbai Airport to Dhanori, ensuring a smooth and timely ride to your destination."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "From budget-friendly sedans to spacious SUVs and premium cars, we have a variety of well-maintained, air-conditioned vehicles to match your requirements for the journey to Dhanori."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are experienced and well-versed with the route from Mumbai Airport to Dhanori. They ensure a safe, efficient, and hassle-free trip with timely navigation."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Mauli Cabs provides upfront pricing with no hidden charges. Enjoy competitive fares for your Mumbai Airport to Dhanori ride with clear and honest rates."
    },
    {
        "WhyChooseheading": "Available 24/7 for Your Convenience",
        "WhyChoosedescription": "Our cabs are available 24/7, so regardless of when your flight lands, we ensure a ride is ready to take you from Mumbai Airport to Dhanori at any time."
    },
    {
        "WhyChooseheading": "Easy Online Booking with Flight Monitoring",
        "WhyChoosedescription": "Book your cab instantly through our website or app. We track your flight's real-time status to ensure that your pickup time adjusts in case of delays."
    },
    {
        "WhyChooseheading": "Sanitized and Comfortable Ride Experience",
        "WhyChoosedescription": "All our vehicles are sanitized before each trip, and we follow strict hygiene protocols to ensure your journey to Dhanori is safe and comfortable."
    },
    {
        "WhyChooseheading": "Flexible Payment Options for Smooth Transactions",
        "WhyChoosedescription": "Pay easily using UPI, credit/debit cards, wallets, or cash. We provide flexible, secure payment options to make your experience more convenient."
    }
]










    }

    const faqData = [
        {
            question: 'How do I book a Mumbai Airport to Dhanori cab with Mauli Cabs?',
            answer: 'Booking a cab from Mumbai Airport to Dhanori is easy. Visit our website or mobile app, enter "Mumbai Airport" as your pickup point and "Dhanori" as your destination. Select your preferred vehicle and confirm the booking. Our 24/7 customer support team is available for assistance.',
        },
        {
            question: 'Can I book a one-way cab from Mumbai Airport to Dhanori?',
            answer: 'Yes, Mauli Cabs provides one-way cab services from Mumbai Airport to Dhanori, perfect for travelers who only need a single drop-off without a return trip.',
        },
        {
            question: 'What types of cars are available for the Mumbai Airport to Dhanori route?',
            answer: 'We offer a variety of vehicles for the Mumbai Airport to Dhanori route, including Hatchbacks, Sedans, SUVs, Ertiga, and Innova Crysta. You can select the vehicle that best suits your comfort, group size, and luggage needs.',
        },
        {
            question: 'Is the fare fixed for Mumbai Airport to Dhanori cab service?',
            answer: 'Yes, Mauli Cabs offers a fixed fare for the Mumbai Airport to Dhanori route, which includes all charges such as tolls, fuel, driver fees, and taxes. The total fare is displayed upfront at the time of booking to ensure transparency.',
        },
        {
            question: 'Can I carry extra luggage in the cab from Mumbai Airport to Dhanori?',
            answer: 'Yes, you can carry extra luggage in your cab. If you have large or bulky items, we recommend choosing an SUV or Innova Crysta for added space and comfort.',
        },
        {
            question: 'Is the Mumbai Airport to Dhanori cab service available 24/7?',
            answer: 'Yes, Mauli Cabs operates 24/7 cab services from Mumbai Airport to Dhanori. Regardless of when your flight arrives, we ensure that your cab will be ready and waiting for you.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh Desai",
            position: "Consultant",
            text: "I rented a car from Mumbai Airport for a business trip. The process was quick, and the car was clean and comfortable. The driver was polite and professional, ensuring a smooth journey. Highly recommend Mauli Cabs!",
            image: "/img/testimonial/testimonial-thumb-1-71.png",
        },
        {
            name: "Ms. Tanya Gupta",
            position: "Travel Enthusiast",
            text: "Booked a car rental from Mumbai Airport for a weekend getaway. The booking process was simple, and the vehicle was perfect for our group. Excellent customer service and a comfortable ride!",
            image: "/img/testimonial/testimonial-thumb-1-72.png",
        },
    ];
    
    
    
    
    






































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    



    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai Airport to Dhanori Cab",
        "description": "Book a reliable and affordable taxi from Mumbai Airport to Dhanori with Mauli Cabs. Enjoy comfortable rides with options for private, luxury, and group travel.",
        "aggregateRating": {
            "@type": "AggregateRating",
            "bestRating": "5",
            "worstRating": "1",
            "ratingValue": "4.9",
            "ratingCount": "1089"
        }
    };
    
  
    

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Mumbai Airport to Dhanori Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
            name="description"
            content="Travel from Mumbai Airport to Dhanori with Mauli Cabs. Book affordable and comfortable taxi services including private, luxury, and group cab options."
        />
        <meta
            name="keywords"
            content="Mumbai Airport to Dhanori cab service, book Mumbai Airport to Dhanori taxi, affordable Mumbai Airport to Dhanori cab, private taxi from Mumbai Airport to Dhanori, Dhanori trip by cab from Mumbai Airport, comfortable taxi ride to Dhanori, luxury taxi for Dhanori trip, group travel to Dhanori from Mumbai Airport"
        />
        <script type="application/ld+json">
            {JSON.stringify(jsonData)}
        </script>
    </Helmet>
            

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/165.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                        Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaiairporttobhanoricabs;